<template>
  <el-main>
    <!-- 類型選擇 -->
    <div>
      <el-radio-group v-model="nowCategoryId" size="medium">
        <el-radio-button v-for="item in categoryList" :key="item.name" :label="item.id">{{item.name}}</el-radio-button>
      </el-radio-group>
    </div>
    <!-- 間隔 -->
    <br>
    <!-- data1 add btn -->
    <el-button v-if="categoryList.length>0" type="primary" @click="data1.addForm1.dialogVisible = true">+ 消息</el-button>
    <!-- 間隔 -->
    <br><br>
    <!-- data1 table -->
    <el-table :data="data1.data" style="width: 100%">
      <el-table-column label="編號">
        <template slot-scope="scope">
          {{scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column  label="日期">
        <template slot-scope="scope">
          {{scope.row.date}}
        </template>
      </el-table-column>
      <el-table-column  label="消息內容">
        <template slot-scope="scope">
          {{scope.row.summarize}}
        </template>
      </el-table-column>
      <el-table-column  label="置頂">
        <template slot-scope="scope">
          {{(scope.row.top == true)? "TOP" : ""}}
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-link v-if="scope.row.contentType==='Url'" :href="scope.row.url" target="_blank">連結</el-link>
          <el-link v-if="scope.row.contentType==='AttachmentFile'" :href="scope.row.url" target="_blank">{{scope.row.attachmentFileName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button @click="data1UpdateForm1DialogOpen(scope.$index)">編輯</el-button>
          <el-button @click="data1Delete(scope.$index)">刪除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- data1 add1 dialog -->
    <el-dialog title="新增" :visible.sync="data1.addForm1.dialogVisible" width="30%" @closed="data1AddForm1DialogClosed()" :close-on-click-modal="false">
      <el-form :model="data1.addForm1.data" status-icon :rules="data1.addForm1.rules" ref="data1AddForm1" label-width="100px" class="demo-ruleForm" v-loading.lock="data1.addForm1.loading">
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="data1.addForm1.data.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="消息內容" prop="summarize">
          <el-input type="textarea" v-model.trim="data1.addForm1.data.summarize" autocomplete="off" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="data1.addForm1.data.top">置頂</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="data1.addForm1.data.contentType">
            <el-radio label="Text">文字</el-radio>
            <el-radio label="Url">連結</el-radio>
            <el-radio label="AttachmentFile">附件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="data1.addForm1.data.contentType==='Url'"  label="連結" prop="url"
        :rules="[
          { required: true, validator: data1AddForm1ValidUrl, trigger: 'blur' },
          // { required: true, message: '請輸入連結', trigger: 'blur' },
        ]">
          <el-input type="text" v-model.trim="data1.addForm1.data.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-show="data1.addForm1.data.contentType==='AttachmentFile'" label="附件" prop="attachmentFile"
        :rules="[
          { required: true, validator: data1AddForm1ValidAttachmentFile, trigger: 'blur' },
          // { required: true, message: '附件不得為空', trigger: 'blur' },
        ]">
          <AttachmentFileUploader :fileQuantityLimit="1" :fileList.sync="data1.addForm1.data.attachmentFile"></AttachmentFileUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert v-show="data1.addForm1.errorMessage.length>0"
            type="error" :closable="false">{{data1.addForm1.errorMessage}}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1AddForm1Submit()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 update1 dialog -->
    <el-dialog title="編輯" :visible.sync="data1.updateForm1.dialogVisible" width="30%" @closed="data1UpdateForm1DialogClosed()" :close-on-click-modal="false">
      <el-form :model="data1.updateForm1.data" status-icon :rules="data1.updateForm1.rules" ref="data1UpdateForm1" label-width="100px" class="demo-ruleForm" v-loading.lock="data1.updateForm1.loading">
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="data1.updateForm1.data.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="消息內容" prop="summarize">
          <el-input type="textarea" v-model.trim="data1.updateForm1.data.summarize" autocomplete="off" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="data1.updateForm1.data.top">置頂</el-checkbox>
        </el-form-item>
        <el-form-item v-show="data1.updateForm1.data.contentType==='Url'"  label="連結" prop="url"
        :rules="[
          { required: true, validator: data1UpdateForm1ValidUrl, trigger: 'blur' },
          // { required: true, message: '請輸入連結', trigger: 'blur' },
        ]">
          <el-input type="text" v-model.trim="data1.updateForm1.data.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-show="data1.updateForm1.data.contentType==='AttachmentFile'" label="附件" prop="attachmentFile"
        :rules="[
          { required: true, validator: data1UpdateForm1ValidAttachmentFile, trigger: 'blur' },
          // { required: true, message: '附件不得為空', trigger: 'blur' },
        ]">
          <AttachmentFileUploader :fileQuantityLimit="1" :fileList.sync="data1.updateForm1.data.attachmentFile"></AttachmentFileUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert v-show="data1.updateForm1.errorMessage.length>0"
            type="error" :closable="false">{{data1.updateForm1.errorMessage}}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1UpdateForm1Submit()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>

import {
  B_News_Category_GetList,
  B_News_Add,
  B_News_GetList,
  B_News_Update,
  B_News_Delete,
} from '@/assets/js/api';
import AttachmentFileUploader from '@/components/AttachmentFileUploader.vue';

export default {
  data() {
    return {
      nowCategoryId: 1,
      categoryList: [],
      data1: {
        data: [
        ],
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: 'data1AddForm1',
          errorMessage: '',
          data: {
            date: '',
            summarize: '',
            name: '',
            top: false,
            contentType: 'Text',
            attachmentFile: [],
            url: '',
          },
          rules: {
            date: [
              { required: true, message: '請輸入日期' },
            ],
            summarize: [
              { required: true, message: '請輸入消息內容' },
              { min: 1, max: 300, message: '消息內容必須在300個字元內' },
            ],
          },
        },
        updateForm1: {
          updateId: 0,
          dialogVisible: false,
          loading: false,
          formRef: 'data1UpdateForm1',
          errorMessage: '',
          data: {
            date: '',
            summarize: '',
            name: '',
            top: false,
            contentType: 'Text',
            attachmentFile: [],
            url: '',
          },
          rules: {
            date: [
              { required: true, message: '請輸入日期' },
            ],
            summarize: [
              { required: true, message: '請輸入消息內容' },
              { min: 1, max: 300, message: '消息內容必須在300個字元內' },
            ],
          },
        },
      },
    };
  },
  components: {
    AttachmentFileUploader,
  },
  mounted() {
    B_News_Category_GetList().then((res) => {
      this.categoryList = res.data.data;
      if (this.categoryList.length > 0) {
        this.nowCategoryId = this.categoryList[0].id;
      }
    }).catch((err) => {
      this.$notify.error({
        title: '錯誤',
        message: err.response.data.message,
      });
    });

    this.data1GetList();
  },
  watch: {
    $route() {
    },
    nowCategoryId() {
      this.data1GetList();
    },
  },
  methods: {
    // 驗證，特殊處理在form內使用v-if造成的bug，改使用v-show，並使用下列的判斷。
    // eslint-disable-next-line no-unused-vars
    data1AddForm1ValidUrl(rule, value, callback) {
      if (this.data1.addForm1.data.contentType === 'Url') {
        if (value === '') {
          callback(new Error('請輸入連結'));
        }
      }
      callback();
    },
    // eslint-disable-next-line no-unused-vars
    data1AddForm1ValidAttachmentFile(rule, value, callback) {
      if (this.data1.addForm1.data.contentType === 'AttachmentFile') {
        if (value.length === 0) {
          callback(new Error('附件不得為空'));
        }
      }
      callback();
    },
    // eslint-disable-next-line no-unused-vars
    data1UpdateForm1ValidUrl(rule, value, callback) {
      if (this.data1.updateForm1.data.contentType === 'Url') {
        if (value === '') {
          callback(new Error('請輸入連結'));
        }
      }
      callback();
    },
    // eslint-disable-next-line no-unused-vars
    data1UpdateForm1ValidAttachmentFile(rule, value, callback) {
      if (this.data1.updateForm1.data.contentType === 'AttachmentFile') {
        if (value.length === 0) {
          callback(new Error('附件不得為空'));
        }
      }
      callback();
    },
    // data1 get list
    data1GetList() {
      B_News_GetList(this.nowCategoryId).then((res) => {
        this.data1.data = res.data.data;
      }).catch((err) => {
        this.$notify.error({
          title: '錯誤',
          message: err.response.data.message,
        });
      });
    },
    // data1 add1
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = '';
    },
    data1AddForm1Submit() {
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.addForm1.loading = true;
          this.data1.addForm1.errorMessage = '';
          const fd = new FormData();
          fd.append('contentType', this.data1.addForm1.data.contentType);
          fd.append('categoryId', this.nowCategoryId);
          fd.append('summarize', this.data1.addForm1.data.summarize);
          fd.append('date', this.data1.addForm1.data.date);
          fd.append('top', this.data1.addForm1.data.top);
          if (this.data1.addForm1.data.contentType === 'AttachmentFile') {
            fd.append('attachmentFile', this.data1.addForm1.data.attachmentFile[0].raw);
          } else if (this.data1.addForm1.data.contentType === 'Url') {
            fd.append('url', this.data1.addForm1.data.url);
          }

          B_News_Add(fd).then(() => {
            this.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
            });
            this.data1.addForm1.dialogVisible = false;
            this.data1GetList();
          }).catch((err) => {
            this.data1.addForm1.errorMessage = err.response.data.message;
            this.data1.addForm1.loading = false;
          });
        }
      });
    },
    // data1 update1
    data1UpdateForm1DialogOpen(index) {
      const thisData = this.data1.data[index];
      this.data1.updateForm1.updateId = this.data1.data[index].id;
      this.data1.updateForm1.dialogVisible = true;

      this.data1.updateForm1.data.contentType = thisData.contentType;
      this.data1.updateForm1.data.date = thisData.date;
      this.data1.updateForm1.data.summarize = thisData.summarize;
      this.data1.updateForm1.data.top = thisData.top;
      if (this.data1.updateForm1.data.contentType === 'AttachmentFile') {
        this.data1.updateForm1.data.attachmentFile = [{
          name: thisData.attachmentFileName,
          url: thisData.url,
          originalFile: true,
        }];
      } else if (this.data1.updateForm1.data.contentType === 'Url') {
        this.data1.updateForm1.data.url = thisData.url;
      }
    },
    data1UpdateForm1DialogClosed() {
      this.data1.updateForm1.loading = false;
      this.$refs[this.data1.updateForm1.formRef].resetFields();
      this.data1.updateForm1.updateId = 0;
      this.data1.updateForm1.errorMessage = '';
    },
    data1UpdateForm1Submit() {
      this.$refs[this.data1.updateForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.updateForm1.errorMessage = '';
          this.data1.updateForm1.loading = true;
          const fd = new FormData();
          fd.append('summarize', this.data1.updateForm1.data.summarize);
          fd.append('date', this.data1.updateForm1.data.date);
          fd.append('top', this.data1.updateForm1.data.top);
          if (this.data1.updateForm1.data.contentType === 'AttachmentFile') {
            const checkPicture = this.data1.updateForm1.data.attachmentFile[0].originalFile !== true;
            if (checkPicture) {
              fd.append('attachmentFile', this.data1.updateForm1.data.attachmentFile[0].raw);
            }
          } else if (this.data1.updateForm1.data.contentType === 'Url') {
            fd.append('url', this.data1.updateForm1.data.url);
          }
          B_News_Update(this.data1.updateForm1.updateId, fd).then(() => {
            this.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
            });
            this.data1.updateForm1.dialogVisible = false;
            this.data1GetList();
          }).catch((err) => {
            this.data1.updateForm1.loading = false;
            this.data1.updateForm1.errorMessage = err.response.data.message;
          });
        }
      });
    },
    // data1 delete
    data1Delete(index) {
      this.$confirm('確定刪除?', '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        B_News_Delete(this.data1.data[index].id).then(() => {
          this.$notify({
            title: '成功',
            message: '刪除成功',
            type: 'success',
          });
          this.data1GetList();
        }).catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: 'warning',
          });
        });
      }).catch(() => {
      });
    },
  },
};
</script>
